//import * as React from "react";
import { Dropdown, DropdownItem } from "flowbite-react/components/Dropdown";
import { ChevronDown, LogOut, KeyRound, UserKey } from "lucide-react";
import { useMemo } from "react";
import userImg from "../../../assets/images/patient1.png";
import { useStore } from "../../../store";
import { useLogout } from "../../app/useLogout";
import { useNavigate } from "@tanstack/react-router";
import { changePasswordRoute } from "../../../router/routes";
import { useTranslation } from "react-i18next";
import { Typography } from "../../../components/ui/Typography";
import { Spinner } from "flowbite-react";
import { toCapitalize } from "@/utils/commonUtils";

const UserMenu = () => {
  const { t } = useTranslation("common");
  const { handleLogout, isLogoutLoading } = useLogout();
  const user = useStore((state) => state.user);
  const navigate = useNavigate();
  const DropDownLable = useMemo(() => {
    return (
      <section
        className="flex cursor-pointer items-center rounded-lg py-1 transition-colors"
        aria-label="User menu"
      >
        <div className="h-8 w-8 overflow-hidden rounded-full">
          <img
            src={userImg}
            alt="user"
            className="h-full w-full object-cover"
          />
        </div>

        <ChevronDown className="ml-1" size={15} />
      </section>
    );
  }, []);

  const handleChangePassword = () => {
    void navigate({ to: changePasswordRoute.to });
  };

  return (
    <div className="user-menu-div">
      <Dropdown
        label=""
        dismissOnClick={true}
        renderTrigger={() => DropDownLable}
        className="rounded-[10px] px-[10px] py-[5px] border shadow-lg"
      >
        <DropdownItem className="flex gap-1 text-start px-1 border-0 items-start hover:bg-transparent">
          <div className="h-8 w-8 overflow-hidden rounded-full">
            <img
              src={userImg}
              alt="user"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="mx-1 flex-1  space-y-0.5">
            <Typography
              className="truncate block leading-none"
              affects={"semiBold"}
              variant={"p"}
            >
              {user?.first_name} {user?.last_name}
            </Typography>
            <Typography variant="small" className="block text-muted-foreground">
              {user?.email}
            </Typography>
            <Typography
              variant="article"
              affects={"medium"}
              className="font_size_11 rounded bg-green/10   text-green px-2 py-0.4 tracking-wide inline-flex gap-1 items-center"
            >
              {user ? toCapitalize(user?.role_group[0]?.slug ?? "") : ""}{" "}
              <UserKey size={11} />
            </Typography>
          </div>
        </DropdownItem>
        <DropdownItem className="flex gap-2 border-t pt-4 border-dashed">
          <div
            role="button"
            className="flex items-center gap-2 w-full p-0  justify-start"
            onClick={handleChangePassword}
          >
            <KeyRound className="text-green" size={16} />
            <span className="text-md">{t("CHANGE_PASSWORD")}</span>
          </div>
        </DropdownItem>

        <DropdownItem className="flex gap-2">
          <div
            role="button"
            className="flex items-center gap-2 w-full p-0 justify-start"
            onClick={(e) => {
              e.stopPropagation(); // now we have access to the event
              if (!isLogoutLoading) {
                void handleLogout();
              }
            }}
            id="logout-button"
          >
            <LogOut className="text-destructive" size={16} />
            <span className="text-md">{t("LOGOUT")}</span>
            {isLogoutLoading && <Spinner size="sm" />}
          </div>
        </DropdownItem>
      </Dropdown>
    </div>
  );
};

export default UserMenu;
